module.exports = __webpack_public_path__ + "static/animation-a5b802cfd855101cbe0384475a10536b.mp4";